import { render, staticRenderFns } from "./ContactAdmin.vue?vue&type=template&id=daf1a1c4&"
import script from "./ContactAdmin.vue?vue&type=script&lang=js&"
export * from "./ContactAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports